import { DotLoader } from '@lifeomic/chroma-react/components/DotLoader';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import { StateMachineState, Test } from '../types';
import { SummaryPanelAndTable } from './SummaryPanelAndTable';
import { useActiveProjectId } from '@lifeomic/phc-web-toolkit/src/hooks/useActiveProjectId';
import { useEffectOnce } from 'react-use';
import * as React from 'react';
import KnowledgeService, {
  GeneSet,
} from '@lifeomic/phc-web-toolkit/src/services/KnowledgeService';
import useService from '@lifeomic/phc-web-toolkit/src/hooks/useService';
// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import mixpanel from 'mixpanel-browser';
import { useActiveAccountId } from '@lifeomic/phc-web-toolkit/src/hooks';
import { Events } from '../../../../src/util/mixpanel/Events';

const knowledgeService = new KnowledgeService();

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
  },
  progressContainer: {
    textAlign: 'center',
  },
  expansionPanel: {
    marginBottom: theme.spacing(4),
  },
  filtersBox: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2),
  },
  filterBox: {
    '&:not(:last-of-type)': {
      marginBottom: theme.spacing(2),
    },
  },
  textBox: {
    width: '12rem',
  },
  filterName: {
    color: theme.palette.text.secondary,
  },
  chipBox: {
    overflowX: 'auto',
  },
}));

interface SummaryViewProps {
  tests?: Array<Test>;
  state: StateMachineState;
}

export const SummaryView: React.FC<SummaryViewProps> = ({ state, tests }) => {
  const classes = useStyles({});

  const accountId = useActiveAccountId();
  const activeProjectId = useActiveProjectId();

  const [geneSets, setGeneSets] = React.useState<Array<GeneSet>>([]);

  const [getGeneSets, getGeneSetsState] = useService(
    knowledgeService.getGeneSets,
  );

  useEffectOnce(() => {
    mixpanel.track(Events.omicsExplorer.navigateToOmicsSummary, {
      accountId,
      projectId: activeProjectId,
    });

    getGeneSets(activeProjectId);
  });

  React.useEffect(() => {
    if (!getGeneSetsState?.response?.data) {
      return;
    }

    setGeneSets(getGeneSetsState?.response?.data?.items);
  }, [getGeneSetsState]);

  return (
    <div className={classes.root}>
      {state === 'INITIALIZING' && (
        <div className={classes.progressContainer}>
          <DotLoader size={1} />
        </div>
      )}
      {state === 'COMPLETE' &&
        tests?.map(test => (
          <SummaryPanelAndTable
            key={test?.id}
            test={test}
            areGeneSetsFetching={getGeneSetsState.isFetching}
            hasCompletedGeneSetsFetch={
              Boolean(getGeneSetsState?.response?.data) ||
              Boolean(getGeneSetsState?.error)
            }
            geneSets={geneSets}
          />
        ))}
    </div>
  );
};
